<template>
  <div class="receipt">
    <hr />

          <v-container>
            <v-layout class="header-details" row wrap>
              <v-flex
                xs12
                sm6
                md4
                class="inspection--row-company">
                <InspectionCompanyHeader :company="hgCompany" />
              </v-flex>

              <v-flex
                xs12
                sm6
                md4
                offset-md4
                class="inspection--row-address">
                <InspectionAddress :receipt="hgReceipt" />
              </v-flex>
            </v-layout>
          </v-container>

          <hr />
          <div v-for="(invoice, index) in hgReceipt.invoices" :key="index">
            <Invoice
            :hg-invoice="invoice"
            :surcharge="surcharge"
            :technology-fee="hgReceipt.technologyFee || 0"  />
            <hr v-if="index !== hgReceipt.invoices.length - 1" />
          </div>

          <hr />

  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';
import { mapState } from 'vuex';
import InspectionCompanyHeader from './Receipt/InspectionCompanyHeader.vue';
import InspectionAddress from './Receipt/InspectionAddress.vue';
import Invoice from './Invoice.vue';

const { CurrencyFilter } = Mixins;

export default {
  mixins: [CurrencyFilter],
  components: {
    InspectionAddress,
    InspectionCompanyHeader,
    Invoice,
  },
  props: {
    hgReceipt: {
      required: true,
      type: Object,
    },
    hgCompany: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState('Company', {
      companyAdditionalChargesSetting: state => state.company.additionalChargesSetting || {},
    }),
    surchargeAmount() {
      return this.hgReceipt.technologyFee ? this.hgReceipt.technologyFee : this.hgReceipt.surcharge;
    },
    surchargeLabel() {
      if (this.hgReceipt.technologyFee) {
        return 'Technology Fee';
      }
      return 'Credit Card Surcharge';
    },
    surcharge() {
      return {
        label: this.surchargeLabel,
        value: this.companyAdditionalChargesSetting.value / 100,
        enabled: this.surchargeAmount ?? false,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.receipt {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.214rem;
}

hr {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 0, 0, 0.15);
  border-width: 0;
  height: 1px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}

@media print {
  .inspection--row-company,
  .inspection--row-address {
    flex-basis: 50% !important;
    flex-grow: 0 !important;
    max-width: 50% !important;
    -ms-flex-positive: 0 !important;
    -ms-flex-preferred-size: 50% !important;
    -webkit-box-flex: 0 !important;
  }
}
</style>
